import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { fromFetch } from 'rxjs/fetch';

/**
 * Schedules an import of Company Data
 */
export function postCompanyScheduleImport(this: unknown) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(fleetEnvironment.resolve(this).companyScheduleImportUrl, {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(ignoreData());
}
